class Notify {
    'use strict';

    constructor(desc = "Przykładowy opis, który możesz zmienić, wpisując własny tekst jako pierwszy argument.", type = "default", duration = 2000) {
        this.desc = desc;
        this.type = type;
        this.duration = duration;
    }

    createContainer() {
        const app = $('body');
        const hasContainer = app.find('.notify-container');
        if (hasContainer.length === 0 ) {
            app.append('<div class="notify-container"></div>');
        }
    }

    hide(element) {
        element.addClass('notify-hide');
        setTimeout(() => {
            element.remove();
            element = null;
        }, 300);
    }

    createNotifier(desc = this.desc, type = this.type, duration = this.duration) {


        this.createContainer();

        $('.notify-container').append(`<small class="notify-element ${type}-notify">${desc}</small>`);
        let element = $(".notify-container").children().last();
        element.show('slide', {direction: 'right', easing: 'linear'}, 300);

        element.on('click', () => {
            this.hide(element);
        });

        setTimeout(() => {
            this.hide(element);
        }, duration);

    }

}

export default Notify;


